
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/analytics';

export let auth: firebase.auth.Auth;
export let db: firebase.database.Database;
export let analytics: firebase.analytics.Analytics;

export const initializeFirebase = async () => {
  console.log("Initializing Firebase...");
  if (firebase.apps.length > 0) {
    console.log("Firebase already initialized, using existing app.");
    const app = firebase.app();
    auth = app.auth();
    db = app.database();
    try {
      analytics = app.analytics();
    } catch (e) {
      console.warn("Analytics initialization failed (likely non-secure context):", e);
    }
    return { auth, db, analytics };
  }

  console.log("Fetching Firebase config from server...");
  const response = await fetch('/api/firebase-config');
  if (!response.ok) {
    throw new Error(`Failed to fetch Firebase config: ${response.statusText}`);
  }
  const firebaseConfig = await response.json();
  console.log("Firebase config received.");

  if (!firebaseConfig.apiKey) {
    throw new Error("Firebase API key is missing. Please configure your environment variables.");
  }

  console.log("Calling firebase.initializeApp...");
  const app = firebase.initializeApp(firebaseConfig);
  auth = app.auth();
  db = app.database();
  
  try {
    console.log("Initializing analytics...");
    analytics = app.analytics();
  } catch (e) {
    console.warn("Analytics initialization failed (likely non-secure context):", e);
  }

  console.log("Firebase initialization complete.");
  return { auth, db, analytics };
};

// We export these as getters so they can be accessed after initialization
export const getAuth = () => auth;
export const getDb = () => db;
export const getAnalytics = () => analytics;
